var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.40332,
    y: 0.144531,
    width: 40.0085,
    height: 40.0085,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.515 21.1484C31.0673 21.1484 31.515 20.7007 31.515 20.1484C31.515 19.5962 31.0673 19.1484 30.515 19.1484V21.1484ZM9.59465 19.4413C9.20413 19.8319 9.20413 20.465 9.59465 20.8555L15.9586 27.2195C16.3491 27.61 16.9823 27.61 17.3728 27.2195C17.7634 26.829 17.7634 26.1958 17.3728 25.8053L11.716 20.1484L17.3728 14.4916C17.7634 14.1011 17.7634 13.4679 17.3728 13.0774C16.9823 12.6868 16.3491 12.6868 15.9586 13.0774L9.59465 19.4413ZM30.515 19.1484H10.3018V21.1484H30.515V19.1484Z",
    fill: "#CB8B65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.d9f2c5c19957f892ab2dc972f25cfa42.svg";
export { ForwardRef as ReactComponent };